import type { ErrorInfo, ReactNode } from "react";

import { Component } from "react";

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
	errorMessage: string;
}

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false, errorMessage: "" };
	}

	static getDerivedStateFromError(_: Error): State {
		console.log({ _ });
		return { hasError: true, errorMessage: _.message };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("ErrorBoundary caught an error", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return <h1>Something went wrong.{this.state.errorMessage}</h1>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
